$(function(){
    $('.column-selector a').click(function(){
        $('.product-grid').css('grid-template-columns', '1fr '.repeat($('span', this).length));
        $('.column-selector a').removeClass('active');
        $(this).addClass('active');
        return false;
    })
})